import React from 'react';
import BrandIdentity from '../../components/BrandIdentity';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function BrandIdentityPage() {
  return (
    <PageLayout title="Identidade Visual" subtitle="Cores e branding" primary={<BrandIdentity />} secondary={null} />
  );
}

export default BrandIdentityPage;
